export default __webpack_public_path__ + "static/media/icon-arrow.d7fae0a8.svg";